import React, { useEffect, useState } from 'react'
import Cookie from 'js-cookie'
import { Route, Redirect } from 'react-router-dom'
import axiosInstance from '../api/axios.instance'
import toast from 'react-hot-toast'
import ToastWarning from '../toast/components/toastWarning/ToastWarning'
import AppLoader from '../shared/ui/AppLoader'

const GalleriesRoute = ({ component: Component, ...rest }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [isAuthorized, setIsAuthorized] = useState(false)
  const accessToken = Cookie.get('vb-access-token')

  // MSN galleries: the gallery editor and admins
  const allowedRoles = ['gallery editor', 'admin']

  useEffect(() => {
    const checkGalleriesAccess = async () => {
      // Если нет токена - сразу редирект на логин
      if (!accessToken) {
        setIsLoading(false)
        setIsAuthorized(false)
        return
      }

      try {
        const { data } = await axiosInstance.post('/auth/authenticate')
        
        if (data?.code === 200) {
          // Проверяем роль пользователя
          if (allowedRoles.includes(data.apiData.role)) {
            setIsAuthorized(true)
          } else {
            // Пользователь авторизован, но не имеет нужную роль
            toast.custom(<ToastWarning text={'Access denied.'} />, {
              duration: 5000,
            })
            setIsAuthorized(false)
          }
        } else {
          setIsAuthorized(false)
        }
      } catch (err) {
        console.log('Galleries access check error:', err)
        
        if (err.response?.data?.code === 401) {
          // Токен истек
          toast.custom(<ToastWarning text={'Session time expired'} />, {
            duration: 5000,
          })
          Cookie.remove('vb-refresh-token')
          Cookie.remove('vb-access-token')
        } else {
          toast.custom(<ToastWarning text={'Access denied'} />, {
            duration: 5000,
          })
        }
        
        setIsAuthorized(false)
      } finally {
        setIsLoading(false)
      }
    }

    checkGalleriesAccess()
  }, [accessToken])

  if (isLoading) {
    // Показываем загрузку пока проверяем доступ
    return (
      <AppLoader />
    )
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!accessToken) {
          // Нет токена - редирект на логин
          return <Redirect to="/login" />
        }
        
        if (isAuthorized) {
          // Пользователь авторизован и имеет нужную роль
          return <Component {...props} />
        } else {
          // Пользователь авторизован, но не имеет нужную роль - редирект на главную
          return <Redirect to="/" />
        }
      }}
    />
  )
}

export default GalleriesRoute
